export { default } from "./ExternalLinkIcon";
